export default __webpack_public_path__ + "static/media/LightBlue0007.f4b771fd.png";